import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as domainApi from '../Api/domainApi';

const DOMAIN_KEY = 'domains';

export const useDomains = (companyId) =>
	useQuery({
		queryKey: [DOMAIN_KEY, companyId],
		queryFn: () =>
			domainApi.getDomains(companyId).then((res) => res.data.domains),
		enabled: !!companyId,
	});

export const useDomain = (domainId, companyId) =>
	useQuery({
		queryKey: [DOMAIN_KEY, domainId, companyId],
		queryFn: () => domainApi.getDomainById(domainId, companyId),
		enabled: !!domainId && !!companyId,
	});

export const useCreateDomain = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ data, companyId }) =>
			domainApi.createDomain(data, companyId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [DOMAIN_KEY] });
		},
	});
};

export const useDeleteDomain = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ domainId, companyId }) =>
			domainApi.deleteDomain(domainId, companyId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [DOMAIN_KEY] });
		},
	});
};

export const useTriggerDnsVerification = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ sendGridDomainId, companyId }) =>
			domainApi.triggerDnsVerification(sendGridDomainId, companyId),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [DOMAIN_KEY] });
		},
	});
};
